<template>
    <div>
        <div class="container-fluid timetable-container">
            <div class="container">
                <div class="row justify-content-center">
                    <div class="col-12">
                        <div class="row">
                            <div class="col-12 order-lg-1 order-5 text-left">
                                <div class="row active-timetables">
                                    <div class="col-12">
                                        <TimetableItemOT :timetable="timetable"
                                                         :subscriptions="getWithoutOneTime(timetable)"
                                                         @order="order"
                                                         @more="more"
                                                         @bonusCourseClick="bonusCourseClick"/>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>
<script>


import moment from 'moment';
import timetableApi from "../data/TimetablesApi";
import subscriptionApi from "../data/SubscriptionApi";
import {isAuthenticated} from "../data/jwt.service";
import userApi from "../data/UserApi";
import TimetableItemOT from "./TimetableItemOT";

export default {
  props: {
    id: {
      type: [Number, String],
    },
  },
  components: {
    TimetableItemOT,
  },
  name: 'TimetableStatic',

  data: function () {
    return {
      timetable: null,
      error: null,
      fieldsErrors: [],
      childFieldsErrors: [],
      loading: false,
      subscriptions: [],
      isMskTimezone: true,
      oneOffSubscriptionIds: [],
      oneOffSubscriptionTimetablesIds: [],
    }
  },


  mounted() {
    moment.locale(this.$i18n.locale)
    this.isMskTimezone = userApi.isMskTimezone()
    this.loading = true
    timetableApi.fetchTimetable(this.id)
        .then(response => {
          this.timetable = response
          this.loading = false
        })
        .catch(error => {
          let data = error.response.data
          this.error = this.pretty(data)
          this.loading = false
        })

    if (isAuthenticated()) {
      userApi.fetchProfile()
          .then(response => {
            //Исключаем одноразовые промо подписки
            this.oneOffSubscriptionIds = response.oneOffSubscriptionIds
            this.oneOffSubscriptionTimetablesIds = response.oneOffSubscriptionTimetablesIds
            subscriptionApi.fetchGroupSubscriptions()
                .then(response => {
                  this.subscriptions = response //.filter(s => ids.indexOf('' + s.idsubscription) === -1)
                })
                .catch(error => {
                  let data = error.response.data
                  this.error = this.pretty(data)
                  this.loading = false
                })
          })
          .catch(error => {
            let data = error.response.data
            this.error = this.pretty(data)
            this.loading = false
          })
    } else {
      subscriptionApi.fetchGroupSubscriptions()
          .then(response => {
            this.subscriptions = response
          })
          .catch(error => {
            let data = error.response.data
            this.error = this.pretty(data)
            this.loading = false
          })
    }
  },

  methods: {
    order(subscription, timetable) {
      if (subscription.stype === 'OnlineTeacher Group')
        this.$router.push('/subscription/order/' + subscription.idsubscription + '/' + timetable.id)
      else
        this.$router.push('/subscription/order/' + subscription.idsubscription)
    },

    bonusCourseClick(subscription) {
      if (subscription.courses && subscription.courses.length > 0) {
        this.$router.push('/course/' + subscription.courses[0].slug)
      }
    },

    more(timetable) {
      this.$router.push('/schedule/' + timetable.id)
    },

    getWithoutOneTime(timetable) {
      if (timetable.subscriptions) {
        if (this.oneOffSubscriptionTimetablesIds.some(el => el == timetable.id)) {
          return timetable.subscriptions.filter(s => this.oneOffSubscriptionIds.indexOf('' + s.idsubscription) === -1)
        }
        return timetable.subscriptions
      } else {
        if (this.oneOffSubscriptionTimetablesIds.some(el => el == timetable.id)) {
          return this.subscriptions.filter(s => this.oneOffSubscriptionIds.indexOf('' + s.idsubscription) === -1).filter(s => s.timetablesCount === 0)
        }
        return this.subscriptions.filter(s => s.timetablesCount === 0)
      }
    },
    pretty(value) {
      console.log(value)
      if (value.message) {
        return value.message
      }
      return JSON.stringify(value, null, 2)
    },
  }
};
</script>
<style src="@/assets/hometeacher/css/main.css">
</style>
